export default function openAuthenticatedFlow(authenticatedFlowUrl: string, practiceToken: string) {
  window.open(`${authenticatedFlowUrl}?practiceToken=${practiceToken}`, "_blank");
}
